exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\ndiv[size=\"sm\"] {\n  width: unset;\n}\ndiv[size=\"sm\"] > .custom-file-input {\n  width: unset;\n}\ndiv[size=\"sm\"] > .custom-file-label {\n  height: calc(1.8125rem + 2px);\n  padding-top: 0.375rem;\n  padding-bottom: 0.375rem;\n  font-size: 0.875rem;\n}\ndiv[size=\"sm\"] > .custom-file-label::after {\n  padding: 0.25rem 0.5rem;\n  font-size: 0.875rem;\n  line-height: 1.5;\n  border-top-right-radius: 0.2rem;\n  border-bottom-right-radius: 0.2rem;\n  height: 1.8125rem;\n}\n", ""]);

// exports
